import { assetUrl } from './assetUrl';

export const SQUARE_PLACEHOLDER = assetUrl('/images/search/squarePlaceholder.webp');
export const EPISODIC_PLACEHOLDER = assetUrl('/images/search/episodicPlaceholder.webp');
export const POSTER_PLACEHOLDER = assetUrl('/images/search/posterPlaceholder.webp');
export const PROMO_TEASER_PLACEHOLDER = assetUrl(
  '/images/search/promoteaserPlaceholder.webp'
);
